@use 'src/global/mixins/icon' as icon;
@use 'src/global/variables';

c-input-salary {
  &.is-disabled {
    cursor: not-allowed;
    background-color: #efefef;
    form {
      input,
      button {
        background-color: #efefef;
        cursor: not-allowed;
      }
    }
  }
  // This is needed for Safari, where the IE background-color fix color from ba-chatbot-component.scss
  // shines through around the edges of the input.
  background-color: text-color-light;
  border-radius: 0 0 8px 8px;
  form {
    display: flex;
    border-radius: 0 0 8px 8px;
    .input-container {
      width: 100%;
      position: relative;
      .currency-text {
        position: absolute;
        left: 1rem;
        top: 50%;
        transform: translateY(-50%);
        color: color-slate-grey;
      }
      input {
        border-radius: 0 0 0 8px;
        // 1px less than smallest iPad
        @media screen and (max-width: 767px) {
          border-radius: 0;
        }
        color: primary-color;
        box-sizing: border-box;
        padding: 1.3rem 1rem;
        font-size: 16px; // To prevent auto zoom in on iPhones, we need font-size >= 16px
        width: 100%;
        border: none;
        text-align: center;

        &::placeholder {
          color: color-slate-grey;
        }

        &:focus {
          z-index: 1;
          outline: none;
          box-shadow: inset 0 0 0 3px focus-color;
        }
      }
    }
    button {
      // 1px less than smallest iPad
      @media screen and (max-width: 767px) {
        border-radius: 0;
      }
      padding: 0 1rem;
      background-color: text-color-light; // Needed on mobile
      border-radius: 0 0 8px 0;
      border: none;
      cursor: pointer;
      display: flex;
      align-items: center; // To center icon if font-size of body gets decreased a lot
      &:focus {
        z-index: 1;
        outline: none;
        box-shadow: inset 0 0 0 3px focus-color;
      }
      i:before {
        font-size: x-large;
        @include icon.icon;
        color: text-color-medium;
        content: '\f119';
      }
    }
  }
}

// Hide default number input arrows
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type='number'] {
  appearance: textfield;
  -moz-appearance: textfield;
  -webkit-appearance: textfield;
}
